// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/img/moça.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/img/user.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/img/email.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/img/telefonee.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/img/CELULAR.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/img/tablet.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Styles */
body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  font-family: 'Arial', sans-serif;
}

/* Home Container */
.home-container {
  display: flex;
  justify-content: flex-end;
  height: 100vh;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center/cover;
}

/* .form-container {
  filter: blur(12px);
  pointer-events: none;
} */

.form-container p {
  margin-top: 0;
}

.form-container h2 {
  margin-bottom: 0;
  line-height: 0.1;
}

#selecao {
  position: absolute;
  color: #ffffff;
  z-index: 2;
  font-size: 3rem;
  font-family: 'Ruberoid-bold', sans-serif;
}

/* Content */
.content {
  display: flex;
  max-width: 60%;
  width: 100%;
  margin-right: 150px;
}

/* Left Content - Text */
.left-content {
  flex: 1 1;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: 'Ruberoid-bold', sans-serif;
}

.left-content h1 {
  font-size: 6.5rem;
  font-weight: bold;
  line-height: 0.8;
  margin: 0;
}

.left-content span {
  font-size: 3.2rem;
  font-weight: bold;
  margin-top: 10px;
}

.subtitle {
  font-size: 5.5em;
  margin-top: 20px;
  font-family: 'Authentic', sans-serif;
  color: #131212;
}

.first-h1 {
  padding-left: 10px;
}

/* Right Content - Form */
.right-content {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Form Box */
.form-box {
  background: rgba(0, 46, 85, 0.7);
  padding: 30px;
  border-radius: 2px;
  border: 1px solid #FFF;
  width: 85%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  color: white;
}

/* Input Fields */
.form-box input[type="text"],
.form-box input[type="email"],
.form-box input[type="tel"] {
  padding: 12px;
  padding-left: 45px; /* Espaço para o ícone */
  border-radius: 5px;
  border: none;
  outline: none;
  font-size: 16px;
  background-repeat: no-repeat;
  background-position: 15px center;
  background-size: 20px;
  transition: background-image 0.3s ease;
}

/* Custom Icons for Inputs */
.form-box input[name="nome"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-box input[name="email"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.form-box input[name="telefone"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.input-container input {
  width: 85%;
}

/* Job Position */
.vaga-title {
  margin-top: 10px;
  font-weight: bold;
}

.vaga-options {
  width: 100%;
  gap: 3rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.vaga-options label {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

/* Upload Section */
.upload-section {
  display: flex;
  gap: 10px;
}

.upload-box {
  width: 48%;
  padding: 15px;
  text-align: center;
  border: 2px dashed #fff;
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}

.upload-box p {
  font-size: 0.8rem;
  margin: 0;
}

.upload-box img {
  max-width: 50px;
  margin: 0 auto;
  width: 100%;
}

.upload-box:hover {
  background: rgba(255, 255, 255, 0.062);
}

/* Privacy Section */
.privacy {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.privacy a {
  color: yellow;
  text-decoration: underline;
}

.privacidade-modal-overlay {
  position: fixed; /* Mantém o modal fixo na tela */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7); /* Fundo escuro translúcido */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 10px; /* Para telas pequenas */
}

.privacidade-modal-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 90%; /* Ajustável */
  max-width: 600px; /* Para telas grandes */
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

/* Conteúdo rolável */
.privacidade-modal-body {
  overflow-y: auto;
  padding: 10px 0;
  max-height: 55vh;
  text-align: justify;
  line-height: 1.5;
  font-size: 14px;
}

/* Rodapé com botões */
.privacidade-modal-footer {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 15px;
}

/* Botões */
.privacidade-modal-btn {
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  flex: 1 1;
  max-width: 48%;
  font-size: 14px;
}

.privacidade-modal-btn-accept {
  background: #4caf50;
  color: white;
}

.privacidade-modal-btn-decline {
  background: #f44336;
  color: white;
}

/* ✅ Responsividade para telas pequenas (celular) */
@media (max-width: 48px) {
  .privacidade-modal-content {
    padding: 15px;
    margin-left: -20px;
    width: 70%; /* ✅ Agora 70% no celular */
    max-height: 85vh; /* Continua com rolagem vertical */
  }

  .privacidade-modal-body {
    max-height: 60vh; /* Conteúdo com rolagem */
    font-size: 13px;
  }

  .privacidade-modal-btn {
    padding: 8px 10px;
    font-size: 12px;
  }

  .privacidade-modal-content h2,
  .privacidade-modal-body h3,
  .privacidade-modal-body h4 {
    font-size: 14px;
  }

} 

/* Submit Button */
.btn {
  margin: 0 auto;
}

/* Custom Checkbox */
.checkbox-btn {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.checkbox-btn input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkbox-btn label {
  cursor: pointer;
  font-size: 14px;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  border: 2.5px solid #ffffff;
  transition: .2s linear;
}

.checkbox-btn input:checked ~ .checkmark {
  background-color: transparent;
}

.checkmark:after {
  content: "";
  position: absolute;
  visibility: hidden;
  opacity: 0;
  left: 50%;
  top: 40%;
  width: 10px;
  height: 14px;
  border: 2px solid #0ea021;
  filter: drop-shadow(0px 0px 10px #0ea021);
  border-width: 0 2.5px 2.5px 0;
  transition: .2s linear;
  transform: translate(-50%, -50%) rotate(-90deg) scale(0.2);
}

.checkbox-btn input:checked ~ .checkmark:after {
  visibility: visible;
  opacity: 1;
  transform: translate(-50%, -50%) rotate(0deg) scale(1);
  animation: pulse 1s ease-in;
}

.checkbox-btn input:checked ~ .checkmark {
  transform: rotate(45deg);
  border: none;
}

@keyframes pulse {
  0%, 100% {
    transform: translate(-50%, -50%) rotate(0deg) scale(1);
  }
  50% {
    transform: translate(-50%, -50%) rotate(0deg) scale(1.6);
  }
}

/* Email Hint */
.email-hint {
  font-size: 0.75rem;
  color: #cdcdcd; /* Cinza discreto */
  margin-top: 3px;
  margin-bottom: 10px;
}

/* Sublinha */
.sublinha {
  line-height: 1px;
  font-size: 0.6rem !important;
}

/* From Uiverse.io by SelfMadeSystem */ 
/* Hide the default checkbox */
.container input {
  display: none;
}

.container {
  display: block;
  position: relative;
  cursor: pointer;
  font-size: 20px;
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: transparent;
}

/* Create a custom checkbox */
.checkmark2 {
  position: relative;
  top: 0;
  left: 0;
  height: 1.3em;
  width: 1.3em;
  background-color: #2196F300;
  border-radius: 0.25em;
  transition: all 0.25s;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark2 {
  background-color: #2196F3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark2:after {
  content: "";
  position: absolute;
  transform: rotate(0deg);
  border: 0.1em solid rgb(255, 255, 255);
  left: 0;
  top: 0;
  width: 1.05em;
  height: 1.05em;
  border-radius: 0.25em;
  transition: all 0.25s, border-width 0.1s;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark2:after {
  left: 0.45em;
  top: 0.25em;
  width: 0.25em;
  height: 0.5em;
  border-color: #fff0 white white #fff0;
  border-width: 0 0.15em 0.15em 0;
  border-radius: 0em;
  transform: rotate(45deg);
}





/* Responsividade geral */
@media (max-width: 395px) {
  .left-content {
    margin-top: 0 !important;
  }

  .vaga-options {
    width: 95%;
  }
}

@media (max-width: 488px) {

  body {
    background-color: #006AA4 !important;
  }
  
  .home-container {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center center/cover;
    background-position: 30%;
    height: 100vh;
    justify-content: center;
  }
  
  .content {
    display: flex;
    max-width: 90%;
    width: 100%;
    margin-right: 0;
    margin-top: 400px;
    flex-direction: column;
}

.left-content {
  margin-top: 150px;
}

.left-content {
  display: flex;
  justify-content: center;
  text-align: left;
}

.right-content {
  padding-bottom: 50px;
}

.input-container {
  width: 94%;
}

.email-hint {
  font-size: 0.6rem;
  color: #cdcdcd; /* Cinza discreto */
  margin-top: 3px;
  margin-bottom: 10px;
}


.left-content h1 {
  font-size: calc(2.5rem + 1vw) !important;
}

.left-content span {
  font-size: 2.3rem;
  margin: 0;
}

.subtitle {
  font-size: calc(2.5rem + 1vw) !important;
  margin-top: 0;
  text-align: center;
}

.sublinha {
  font-size: 0.8rem !important;
  margin-top: 5px !important;
  font-weight: 100;
  line-height: normal;
}

.upload-box {
  gap: 10px;
}

.upload-box img {
  max-width: 30px;
}
}

@media (min-width: 489px) and (max-width: 880px) {
  body {
    background-color: #006AA4 !important;
  }
  
  .home-container {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center center/cover;
    background-position: 30%;
  }

  .content {
    display: flex;
    max-width: 100%;
    width: 100%;
    margin-right: 0;
    margin-top: 230px;
    flex-direction: column;
  }

  .left-content {
    margin-left: 350px;
  }

  .left-content h1 {
    font-size: calc(2.5rem + 1vw) !important;
  }

  .subtitle {
    font-size: calc(2.5rem + 1vw) !important;
    margin-top: 0;
  }

  .right-content {
    margin-bottom: 80px;
  }

  .form-box {
    padding: 20px;
    width: 75%;
    max-width: 350px;
    gap: 10px;
  }


  .upload-box {
    width: 45%;
    padding: 20px;
  }

  .upload-box img {
    max-width: 30px;
  }

  .checkbox-btn label {
    font-size: 12px;
  }

  .sublinha {
    line-height: normal;
  }

  .privacy {
    font-size: 10px;
  }
}

@media (min-width: 1200px) {
  .home-container {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center/cover;
    background-position: 30%;
  }

  .content {
    max-width: 70%;
    margin-right: 100px;
  }
  
  .left-content {
    margin-top: 150px;
  }

  .left-content h1 {
    font-size: calc(2.5rem + 1vw) !important;
  }

  .left-content span {
    font-size: 2.3rem;
  }

  .subtitle {
    font-size: calc(3.5em + 1vw) !important;
  }

  .sublinha {
    font-size: 0.8rem !important;
    margin-top: 5px !important;
    font-weight: 100;
  }

  .upload-box {
    gap: 10px;
  }
}

@media (max-width: 1200px) {
  .left-content h1 {
    font-size: 5rem;
  }

  .left-content span {
    font-size: 2.5rem;
  }
}

@media (max-width: 1024px) {
  .left-content h1 {
    font-size: 4rem;
  }

  .left-content span {
    font-size: 2rem;
  }
}

@media (max-width: 810px) {
  .left-content h1 {
    font-size: 3.5rem;
  }

  .left-content span {
    font-size: 1.8rem;
  }
}

@media (min-width: 1600px) {
  .left-content h1 {
    font-size: 8rem;
  }

}
`, "",{"version":3,"sources":["webpack://./src/styles/Home.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,iFAAqE;AACvE;;AAEA;;;GAGG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,eAAe;EACf,wCAAwC;AAC1C;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA,iBAAiB;AACjB;;;EAGE,aAAa;EACb,kBAAkB,EAAE,wBAAwB;EAC5C,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,4BAA4B;EAC5B,gCAAgC;EAChC,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA,4BAA4B;AAC5B;EACE,yDAA6C;AAC/C;;AAEA;EACE,yDAA8C;AAChD;;AAEA;EACE,yDAAkD;AACpD;;AAEA;EACE,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,oCAAoC;EACpC,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,eAAe,EAAE,gCAAgC;EACjD,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,6BAA6B;EAC7D,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa,EAAE,wBAAwB;AACzC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,UAAU,EAAE,cAAc;EAC1B,gBAAgB,EAAE,uBAAuB;EACzC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,SAAO;EACP,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,mDAAmD;AACnD;EACE;IACE,aAAa;IACb,kBAAkB;IAClB,UAAU,EAAE,2BAA2B;IACvC,gBAAgB,EAAE,kCAAkC;EACtD;;EAEA;IACE,gBAAgB,EAAE,yBAAyB;IAC3C,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;;IAGE,eAAe;EACjB;;AAEF;;AAEA,kBAAkB;AAClB;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yCAAyC;EACzC,6BAA6B;EAC7B,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,sDAAsD;EACtD,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE;IACE,sDAAsD;EACxD;EACA;IACE,wDAAwD;EAC1D;AACF;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,cAAc,EAAE,mBAAmB;EACnC,eAAe;EACf,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,sCAAsC;AACtC,8BAA8B;AAC9B;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,wDAAwD;AACxD;EACE,yBAAyB;AAC3B;;AAEA,6DAA6D;AAC7D;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,sCAAsC;EACtC,OAAO;EACP,MAAM;EACN,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,wBAAwB;AAC1B;;;;;;AAMA,yBAAyB;AACzB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;;EAEE;IACE,oCAAoC;EACtC;;EAEA;IACE,iFAAwE;IACxE,wBAAwB;IACxB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc,EAAE,mBAAmB;EACnC,eAAe;EACf,mBAAmB;AACrB;;;AAGA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;AACA;;AAEA;EACE;IACE,oCAAoC;EACtC;;EAEA;IACE,iFAAuE;IACvE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,eAAe;IACf,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,wCAAwC;IACxC,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,SAAS;EACX;;;EAGA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iFAAqE;IACrE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;AAEF","sourcesContent":["/* Global Styles */\nbody, html {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 100%;\n  font-family: 'Arial', sans-serif;\n}\n\n/* Home Container */\n.home-container {\n  display: flex;\n  justify-content: flex-end;\n  height: 100vh;\n  background: url('/public/img/moça.png') no-repeat center center/cover;\n}\n\n/* .form-container {\n  filter: blur(12px);\n  pointer-events: none;\n} */\n\n.form-container p {\n  margin-top: 0;\n}\n\n.form-container h2 {\n  margin-bottom: 0;\n  line-height: 0.1;\n}\n\n#selecao {\n  position: absolute;\n  color: #ffffff;\n  z-index: 2;\n  font-size: 3rem;\n  font-family: 'Ruberoid-bold', sans-serif;\n}\n\n/* Content */\n.content {\n  display: flex;\n  max-width: 60%;\n  width: 100%;\n  margin-right: 150px;\n}\n\n/* Left Content - Text */\n.left-content {\n  flex: 1;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  font-family: 'Ruberoid-bold', sans-serif;\n}\n\n.left-content h1 {\n  font-size: 6.5rem;\n  font-weight: bold;\n  line-height: 0.8;\n  margin: 0;\n}\n\n.left-content span {\n  font-size: 3.2rem;\n  font-weight: bold;\n  margin-top: 10px;\n}\n\n.subtitle {\n  font-size: 5.5em;\n  margin-top: 20px;\n  font-family: 'Authentic', sans-serif;\n  color: #131212;\n}\n\n.first-h1 {\n  padding-left: 10px;\n}\n\n/* Right Content - Form */\n.right-content {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Form Box */\n.form-box {\n  background: rgba(0, 46, 85, 0.7);\n  padding: 30px;\n  border-radius: 2px;\n  border: 1px solid #FFF;\n  width: 85%;\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  color: white;\n}\n\n/* Input Fields */\n.form-box input[type=\"text\"],\n.form-box input[type=\"email\"],\n.form-box input[type=\"tel\"] {\n  padding: 12px;\n  padding-left: 45px; /* Espaço para o ícone */\n  border-radius: 5px;\n  border: none;\n  outline: none;\n  font-size: 16px;\n  background-repeat: no-repeat;\n  background-position: 15px center;\n  background-size: 20px;\n  transition: background-image 0.3s ease;\n}\n\n/* Custom Icons for Inputs */\n.form-box input[name=\"nome\"] {\n  background-image: url('/public/img/user.png');\n}\n\n.form-box input[name=\"email\"] {\n  background-image: url('/public/img/email.png');\n}\n\n.form-box input[name=\"telefone\"] {\n  background-image: url('/public/img/telefonee.png');\n}\n\n.input-container input {\n  width: 85%;\n}\n\n/* Job Position */\n.vaga-title {\n  margin-top: 10px;\n  font-weight: bold;\n}\n\n.vaga-options {\n  width: 100%;\n  gap: 3rem;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n}\n\n.vaga-options label {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n/* Upload Section */\n.upload-section {\n  display: flex;\n  gap: 10px;\n}\n\n.upload-box {\n  width: 48%;\n  padding: 15px;\n  text-align: center;\n  border: 2px dashed #fff;\n  color: #fff;\n  background: rgba(255, 255, 255, 0.1);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.upload-box p {\n  font-size: 0.8rem;\n  margin: 0;\n}\n\n.upload-box img {\n  max-width: 50px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.upload-box:hover {\n  background: rgba(255, 255, 255, 0.062);\n}\n\n/* Privacy Section */\n.privacy {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n}\n\n.privacy a {\n  color: yellow;\n  text-decoration: underline;\n}\n\n.privacidade-modal-overlay {\n  position: fixed; /* Mantém o modal fixo na tela */\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7); /* Fundo escuro translúcido */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n  padding: 10px; /* Para telas pequenas */\n}\n\n.privacidade-modal-content {\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  width: 90%; /* Ajustável */\n  max-width: 600px; /* Para telas grandes */\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n}\n\n/* Conteúdo rolável */\n.privacidade-modal-body {\n  overflow-y: auto;\n  padding: 10px 0;\n  max-height: 55vh;\n  text-align: justify;\n  line-height: 1.5;\n  font-size: 14px;\n}\n\n/* Rodapé com botões */\n.privacidade-modal-footer {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n/* Botões */\n.privacidade-modal-btn {\n  padding: 10px 15px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-weight: bold;\n  flex: 1;\n  max-width: 48%;\n  font-size: 14px;\n}\n\n.privacidade-modal-btn-accept {\n  background: #4caf50;\n  color: white;\n}\n\n.privacidade-modal-btn-decline {\n  background: #f44336;\n  color: white;\n}\n\n/* ✅ Responsividade para telas pequenas (celular) */\n@media (max-width: 48px) {\n  .privacidade-modal-content {\n    padding: 15px;\n    margin-left: -20px;\n    width: 70%; /* ✅ Agora 70% no celular */\n    max-height: 85vh; /* Continua com rolagem vertical */\n  }\n\n  .privacidade-modal-body {\n    max-height: 60vh; /* Conteúdo com rolagem */\n    font-size: 13px;\n  }\n\n  .privacidade-modal-btn {\n    padding: 8px 10px;\n    font-size: 12px;\n  }\n\n  .privacidade-modal-content h2,\n  .privacidade-modal-body h3,\n  .privacidade-modal-body h4 {\n    font-size: 14px;\n  }\n\n} \n\n/* Submit Button */\n.btn {\n  margin: 0 auto;\n}\n\n/* Custom Checkbox */\n.checkbox-btn {\n  display: block;\n  position: relative;\n  padding-left: 30px;\n  margin-bottom: 10px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.checkbox-btn input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\n.checkbox-btn label {\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.checkmark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 15px;\n  width: 15px;\n  border: 2.5px solid #ffffff;\n  transition: .2s linear;\n}\n\n.checkbox-btn input:checked ~ .checkmark {\n  background-color: transparent;\n}\n\n.checkmark:after {\n  content: \"\";\n  position: absolute;\n  visibility: hidden;\n  opacity: 0;\n  left: 50%;\n  top: 40%;\n  width: 10px;\n  height: 14px;\n  border: 2px solid #0ea021;\n  filter: drop-shadow(0px 0px 10px #0ea021);\n  border-width: 0 2.5px 2.5px 0;\n  transition: .2s linear;\n  transform: translate(-50%, -50%) rotate(-90deg) scale(0.2);\n}\n\n.checkbox-btn input:checked ~ .checkmark:after {\n  visibility: visible;\n  opacity: 1;\n  transform: translate(-50%, -50%) rotate(0deg) scale(1);\n  animation: pulse 1s ease-in;\n}\n\n.checkbox-btn input:checked ~ .checkmark {\n  transform: rotate(45deg);\n  border: none;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: translate(-50%, -50%) rotate(0deg) scale(1);\n  }\n  50% {\n    transform: translate(-50%, -50%) rotate(0deg) scale(1.6);\n  }\n}\n\n/* Email Hint */\n.email-hint {\n  font-size: 0.75rem;\n  color: #cdcdcd; /* Cinza discreto */\n  margin-top: 3px;\n  margin-bottom: 10px;\n}\n\n/* Sublinha */\n.sublinha {\n  line-height: 1px;\n  font-size: 0.6rem !important;\n}\n\n/* From Uiverse.io by SelfMadeSystem */ \n/* Hide the default checkbox */\n.container input {\n  display: none;\n}\n\n.container {\n  display: block;\n  position: relative;\n  cursor: pointer;\n  font-size: 20px;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* Create a custom checkbox */\n.checkmark2 {\n  position: relative;\n  top: 0;\n  left: 0;\n  height: 1.3em;\n  width: 1.3em;\n  background-color: #2196F300;\n  border-radius: 0.25em;\n  transition: all 0.25s;\n}\n\n/* When the checkbox is checked, add a blue background */\n.container input:checked ~ .checkmark2 {\n  background-color: #2196F3;\n}\n\n/* Create the checkmark/indicator (hidden when not checked) */\n.checkmark2:after {\n  content: \"\";\n  position: absolute;\n  transform: rotate(0deg);\n  border: 0.1em solid rgb(255, 255, 255);\n  left: 0;\n  top: 0;\n  width: 1.05em;\n  height: 1.05em;\n  border-radius: 0.25em;\n  transition: all 0.25s, border-width 0.1s;\n}\n\n/* Show the checkmark when checked */\n.container input:checked ~ .checkmark2:after {\n  left: 0.45em;\n  top: 0.25em;\n  width: 0.25em;\n  height: 0.5em;\n  border-color: #fff0 white white #fff0;\n  border-width: 0 0.15em 0.15em 0;\n  border-radius: 0em;\n  transform: rotate(45deg);\n}\n\n\n\n\n\n/* Responsividade geral */\n@media (max-width: 395px) {\n  .left-content {\n    margin-top: 0 !important;\n  }\n\n  .vaga-options {\n    width: 95%;\n  }\n}\n\n@media (max-width: 488px) {\n\n  body {\n    background-color: #006AA4 !important;\n  }\n  \n  .home-container {\n    background: url('/public/img/CELULAR.png') no-repeat center center/cover;\n    background-position: 30%;\n    height: 100vh;\n    justify-content: center;\n  }\n  \n  .content {\n    display: flex;\n    max-width: 90%;\n    width: 100%;\n    margin-right: 0;\n    margin-top: 400px;\n    flex-direction: column;\n}\n\n.left-content {\n  margin-top: 150px;\n}\n\n.left-content {\n  display: flex;\n  justify-content: center;\n  text-align: left;\n}\n\n.right-content {\n  padding-bottom: 50px;\n}\n\n.input-container {\n  width: 94%;\n}\n\n.email-hint {\n  font-size: 0.6rem;\n  color: #cdcdcd; /* Cinza discreto */\n  margin-top: 3px;\n  margin-bottom: 10px;\n}\n\n\n.left-content h1 {\n  font-size: calc(2.5rem + 1vw) !important;\n}\n\n.left-content span {\n  font-size: 2.3rem;\n  margin: 0;\n}\n\n.subtitle {\n  font-size: calc(2.5rem + 1vw) !important;\n  margin-top: 0;\n  text-align: center;\n}\n\n.sublinha {\n  font-size: 0.8rem !important;\n  margin-top: 5px !important;\n  font-weight: 100;\n  line-height: normal;\n}\n\n.upload-box {\n  gap: 10px;\n}\n\n.upload-box img {\n  max-width: 30px;\n}\n}\n\n@media (min-width: 489px) and (max-width: 880px) {\n  body {\n    background-color: #006AA4 !important;\n  }\n  \n  .home-container {\n    background: url('/public/img/tablet.png') no-repeat center center/cover;\n    background-position: 30%;\n  }\n\n  .content {\n    display: flex;\n    max-width: 100%;\n    width: 100%;\n    margin-right: 0;\n    margin-top: 230px;\n    flex-direction: column;\n  }\n\n  .left-content {\n    margin-left: 350px;\n  }\n\n  .left-content h1 {\n    font-size: calc(2.5rem + 1vw) !important;\n  }\n\n  .subtitle {\n    font-size: calc(2.5rem + 1vw) !important;\n    margin-top: 0;\n  }\n\n  .right-content {\n    margin-bottom: 80px;\n  }\n\n  .form-box {\n    padding: 20px;\n    width: 75%;\n    max-width: 350px;\n    gap: 10px;\n  }\n\n\n  .upload-box {\n    width: 45%;\n    padding: 20px;\n  }\n\n  .upload-box img {\n    max-width: 30px;\n  }\n\n  .checkbox-btn label {\n    font-size: 12px;\n  }\n\n  .sublinha {\n    line-height: normal;\n  }\n\n  .privacy {\n    font-size: 10px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .home-container {\n    background: url('/public/img/moça.png') no-repeat center center/cover;\n    background-position: 30%;\n  }\n\n  .content {\n    max-width: 70%;\n    margin-right: 100px;\n  }\n  \n  .left-content {\n    margin-top: 150px;\n  }\n\n  .left-content h1 {\n    font-size: calc(2.5rem + 1vw) !important;\n  }\n\n  .left-content span {\n    font-size: 2.3rem;\n  }\n\n  .subtitle {\n    font-size: calc(3.5em + 1vw) !important;\n  }\n\n  .sublinha {\n    font-size: 0.8rem !important;\n    margin-top: 5px !important;\n    font-weight: 100;\n  }\n\n  .upload-box {\n    gap: 10px;\n  }\n}\n\n@media (max-width: 1200px) {\n  .left-content h1 {\n    font-size: 5rem;\n  }\n\n  .left-content span {\n    font-size: 2.5rem;\n  }\n}\n\n@media (max-width: 1024px) {\n  .left-content h1 {\n    font-size: 4rem;\n  }\n\n  .left-content span {\n    font-size: 2rem;\n  }\n}\n\n@media (max-width: 810px) {\n  .left-content h1 {\n    font-size: 3.5rem;\n  }\n\n  .left-content span {\n    font-size: 1.8rem;\n  }\n}\n\n@media (min-width: 1600px) {\n  .left-content h1 {\n    font-size: 8rem;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
